// Champs traduits : quand une valeur est un objet { fr, en } plutot
// qu'une chaine simple, c'est que ce texte a une vraie traduction (role,
// descriptions, libelles de video). Les noms propres (titre du projet,
// client) restent des chaines simples dans les deux langues plutot que
// d'inventer une traduction a un titre de film/evenement/marque.
export const pickLang = (field, lang) => {
  if (field == null) return field;
  if (typeof field === 'object' && !Array.isArray(field)) {
    return field[lang] || field.fr || Object.values(field)[0] || '';
  }
  return field;
};

export const projects = [

  {
    id: '10',
    title: 'PSG',
    thumbnail: '/images/projects/psg/psg_hero.jpg',

    meta: {
      client: 'PSG',
      year: '2026',
      role: { fr: 'Superviseur VFX / Artiste VFX', en: 'VFX Supervisor / VFX Artist' },
      type: 'Publicité',
      category: 'Ads'
    },

    content: {
      about: {
        fr: "Spot publicitaire réalisé pour le Paris Saint-Germain à l'occasion de la présentation de ses nouveaux maillots.",
        en: "Advertising spot created for Paris Saint-Germain to unveil the club's new jerseys.",
      },
      intent: {
        fr: "Mettre en scène l'identité du club à travers un contenu à la fois réaliste et spectaculaire.",
        en: "Bring the club's identity to life through content that is both realistic and spectacular.",
      },
      process: {
        fr: "Supervision VFX et création d'effets visuels pour enrichir les prises de vues réelles.",
        en: "VFX supervision and visual effects work to enhance the live-action footage.",
      },
      summary: {
        fr: "Spot publicitaire réalisé pour le Paris Saint-Germain à l'occasion de la présentation de ses nouveaux maillots, mêlant prises de vues réelles et effets visuels pour mettre en scène l'identité du club.",
        en: "Advertising spot created for Paris Saint-Germain to unveil the club's new jerseys, blending live-action footage with visual effects to bring the club's identity to life.",
      },
    },

    videos: [
      { type: "mp4", src: '/images/projects/psg/psg_vid1.mp4', label: { fr: 'extrait 1', en: 'clip 1' } },
    ],

    breakdownVideo: '/images/projects/psg/psg_making_of.mp4',

    images: [
      '/images/projects/psg/psg_hero.jpg',
      '/images/projects/psg/1.jpg',
      '/images/projects/psg/2.jpg',
      '/images/projects/psg/3.jpg',
      '/images/projects/psg/4.jpg',
      '/images/projects/psg/5.jpg',
    ],

    deckImages: [
      '/images/projects/psg/d1.jpg',
      '/images/projects/psg/d2.jpg',
      '/images/projects/psg/d3.jpg',
      '/images/projects/psg/d4.jpg',
    ],
  },

  {
    id: '6',
    title: 'Aya',
    thumbnail: '/images/projects/aya/aya_hero.jpg',

    meta: {
      client: 'Aya Nakamura',
      year: '2026',
      role: { fr: 'Assistant opérateur caméra / Superviseur VFX', en: 'Assistant Camera Operator / VFX Supervisor' },
      type: 'Promotion',
      category: 'Ads'
    },

    content: {
      about: {
        fr: "Vidéo promotionnelle réalisée pour Aya et pensée pour les réseaux sociaux. Le projet repose sur trois plans mêlant tournage réel et effets visuels.",
        en: "Promotional video created for Aya and designed for social media. The project is built around three shots blending live-action footage and visual effects.",
      },
      intent: {
        fr: "Créer un contenu moderne et impactant capable de capter l’attention rapidement.",
        en: "Create modern, impactful content able to quickly capture attention.",
      },
      process: {
        fr: "Création des FX et intégration d’environnements pour enrichir la mise en scène.",
        en: "FX creation and environment integration to enrich the staging.",
      },
      summary: {
        fr: "Vidéo promotionnelle réalisée pour Aya et pensée pour les réseaux sociaux, mêlant tournage réel et effets visuels sur trois plans. L’objectif : un contenu moderne et impactant, capable de capter l’attention rapidement — porté par la création des FX et l’intégration d’environnements qui enrichissent la mise en scène.",
        en: "Promotional video created for Aya and designed for social media, blending live-action footage and visual effects across three shots. The goal: modern, impactful content able to quickly capture attention — driven by FX creation and environment integration that enrich the staging.",
      },
    },

    videos: [
      { type: "mp4", src: '/images/projects/aya/aya_vid1.mp4', label: { fr: 'extrait 1', en: 'clip 1' } },
      { type: "mp4", src: '/images/projects/aya/aya_vid2.mp4', label: { fr: 'extrait 2', en: 'clip 2' } },
      { type: "instagram", src: "https://www.instagram.com/reel/DRm5lTyCDdU/", label: { fr: 'Reel', en: 'Reel' } },
      { type: "mp4", src: '/images/projects/aya/aya_vid3.mp4', label: { fr: 'extrait 3', en: 'clip 3' } },
    ],

    breakdownVideo: '/images/projects/aya/making_of_NY.mp4',
    breakdownThumbnail: '/images/projects/hextech/hextech_hero.jpg',

    images: [
      '/images/projects/aya/aya_hero.jpg',
      '/images/projects/aya/1.jpg',
      '/images/projects/aya/2.jpg',
      '/images/projects/aya/3.jpg',
      '/images/projects/aya/4.jpg',
    ],

    deckImages: [
      '/images/projects/aya/d1.jpg',
      '/images/projects/aya/d2.jpg',
      '/images/projects/aya/d3.jpg',
      '/images/projects/aya/d4.jpg',
    ],
  },

  {
    id: '5',
    title: 'Tournée des Zenith',
    thumbnail: '/images/projects/suzanne/suz_hero.jpg',

    meta: {
      client: 'Suzanne music',
      year: '2025',
      role: { fr: 'Superviseur VFX', en: 'VFX Supervisor' },
      type: 'Promotion',
      category: 'Ads'
    },

    // --- SUZANNE ---
    content: {
      about: {
        fr: "Annonce visuelle de la tournée des Zénith de l’artiste Suzanne à travers une vidéo promotionnelle.",
        en: "Visual announcement for artist Suzanne's Zénith tour, through a promotional video.",
      },
      intent: {
        fr: "Concevoir une vidéo courte au rythme d’un film d’action.",
        en: "Design a short video with the pace of an action film.",
      },
      process: {
        fr: "Modélisation et animation de multiples écrans intégrés dans un plan réel.",
        en: "Modeling and animation of multiple screens integrated into a live-action shot.",
      },
      summary: {
        fr: "Annonce visuelle de la tournée des Zénith de l’artiste Suzanne à travers une vidéo promotionnelle, conçue comme une vidéo courte au rythme d’un film d’action. Le projet repose sur la modélisation et l’animation de multiples écrans intégrés dans un plan réel.",
        en: "Visual announcement for artist Suzanne's Zénith tour through a promotional video, designed as a short video with the pace of an action film. The project is built on the modeling and animation of multiple screens integrated into a live-action shot.",
      },
    },


    videos: [
      { type: "mp4", src: '/images/projects/suzanne/suzanne_vid.mp4', label: { fr: 'extrait 1', en: 'clip 1' } },
      { type: "instagram", src: "https://www.instagram.com/reel/DHa0mfxN16K/", label: { fr: 'Reel', en: 'Reel' } },
    ],

    breakdownVideo: '/images/projects/suzanne/suzanne-mo.mp4',

    images: [
      '/images/projects/suzanne/suz_hero.jpg',
      '/images/projects/suzanne/1.jpg',
    ],

    deckImages: [
      '/images/projects/suzanne/d2.jpg',
      '/images/projects/suzanne/d25.jpg',
      '/images/projects/suzanne/d3.jpg',
      '/images/projects/suzanne/d4.jpg',
    ],
  },

  {
    id: '3',
    title: 'Editing con',
    thumbnail: '/images/projects/editcon/editcon_hero.jpg',

    meta: {
      client: 'Sam editing',
      year: '2025',
      role: { fr: 'Chef opérateur image / Superviseur VFX', en: 'Director of Photography / VFX Supervisor' },
      type: 'Promotion',
      category: 'Ads'
    },

    content: {
      about: {
        fr: "Projet publicitaire mêlant montage rapide et effets visuels pour la promotion de l’Editing Con organisé par Sam.",
        en: "Advertising project blending fast-paced editing and visual effects to promote the Editing Con event organized by Sam.",
      },
      intent: {
        fr: "Créer une vidéo courte et très rythmée mettant en valeur le montage et la post-production.",
        en: "Create a short, highly rhythmic video highlighting editing and post-production.",
      },
      process: {
        fr: "Utilisation d’un bras robotisé pour faciliter la création de plans à effets spéciaux.",
        en: "Use of a robotic arm to facilitate the creation of special-effects shots.",
      },
      summary: {
        fr: "Projet publicitaire mêlant montage rapide et effets visuels pour la promotion de l’Editing Con organisé par Sam, pensé comme une vidéo courte et très rythmée mettant en valeur le montage et la post-production. Les plans à effets spéciaux ont été facilités par l’utilisation d’un bras robotisé.",
        en: "Advertising project blending fast-paced editing and visual effects to promote the Editing Con event organized by Sam, designed as a short, highly rhythmic video highlighting editing and post-production. The special-effects shots were made possible with a robotic arm.",
      },
    },

    videos: [
      { type: "mp4", src: '/images/projects/editcon/ext_1.mp4', label: { fr: 'extrait 1', en: 'clip 1' } },
      { type: "mp4", src: '/images/projects/editcon/ext_2.mp4', label: { fr: 'extrait 2', en: 'clip 2' } },
      { type: "instagram", src: "https://www.instagram.com/reel/DRm5lTyCDdU/", label: { fr: 'Reel', en: 'Reel' } },
      { type: "mp4", src: '/images/projects/editcon/ext_3.mp4', label: { fr: 'extrait 3', en: 'clip 3' } },
      { type: "mp4", src: '/images/projects/editcon/ext_4.mp4', label: { fr: 'extrait 4', en: 'clip 4' } },
    ],

    breakdownVideo: '/images/projects/editcon/editcon_mo.mp4',
    breakdownThumbnail: '/images/projects/hextech/hextech_hero.jpg',

    images: [
      '/images/projects/editcon/editcon_hero.jpg',
      '/images/projects/editcon/editcon_2.jpg',
      '/images/projects/editcon/editcon_1.jpg',
      '/images/projects/editcon/editcon_3.jpg',
      '/images/projects/editcon/editcon_4.jpg',
      '/images/projects/editcon/editcon_5.jpg',
    ],

    deckImages: [
      '/images/projects/editcon/editcon_c1.jpg',
      '/images/projects/editcon/editcon_c2.jpg',
      '/images/projects/editcon/editcon_c3.jpg',
      '/images/projects/editcon/editcon_c4.jpg',
    ],
  },

  {
    id: '4',
    title: 'Olympe rave',
    thumbnail: '/images/projects/rave/rave_hero.jpg',

    meta: {
      client: 'Olympe rave',
      year: '2025',
      role: { fr: 'Superviseur VFX', en: 'VFX Supervisor' },
      type: 'Promotion',
      category: 'Ads'
    },

    content: {
      about: {
        fr: "Vidéo promotionnelle pour la quatrième édition de l’événement Olympe Rave.",
        en: "Promotional video for the fourth edition of the Olympe Rave event.",
      },
      intent: {
        fr: "Transmettre l’énergie de l’événement à travers une animation 3D courte.",
        en: "Convey the event's energy through a short 3D animation.",
      },
      process: {
        fr: "Modélisation et animation sous Cinema 4D avec rendu Octane.",
        en: "Modeling and animation in Cinema 4D with Octane rendering.",
      },
      summary: {
        fr: "Vidéo promotionnelle pour la quatrième édition de l’événement Olympe Rave, pensée pour transmettre son énergie à travers une animation 3D courte. Modélisation et animation réalisées sous Cinema 4D, avec un rendu Octane.",
        en: "Promotional video for the fourth edition of the Olympe Rave event, designed to convey its energy through a short 3D animation. Modeling and animation done in Cinema 4D, with Octane rendering.",
      },
    },

    videos: [
      { type: "mp4", src: '/images/projects/rave/rave_vid.mp4', label: { fr: 'extrait 1', en: 'clip 1' } },
    ],

    images: [
      '/images/projects/rave/rave_1.jpg',
      '/images/projects/rave/rave_1.jpg',
      '/images/projects/rave/rave_2.jpg',
      '/images/projects/rave/rave_3.jpg',
      '/images/projects/rave/rave_4.jpg',
      '/images/projects/rave/rave_5.jpg',
    ],
  },

  {
    id: '8',
    title: 'Les mots des autres',
    thumbnail: '/images/projects/f15/1.jpg',

    meta: {
      client: 'Aya Nakamura',
      year: '2026',
      role: { fr: 'Chef opérateur image', en: 'Director of Photography' },
      type: 'Narrative',
      category: 'Fiction'
    },

    content: {
      about: {
        fr: "Court métrage narratif explorant le langage, les émotions et la relation aux mots.",
        en: "Narrative short film exploring language, emotion, and our relationship to words.",
      },
      intent: {
        fr: "Créer un univers immersif porté par l’image et la sensibilité des plans.",
        en: "Create an immersive world carried by the imagery and the sensitivity of the shots.",
      },
      notes: {
        fr: "Remerciements à toute l’équipe pour son investissement dans ce projet ambitieux.",
        en: "Thanks to the whole crew for their commitment to this ambitious project.",
      },
      summary: {
        fr: "Court métrage narratif explorant le langage, les émotions et la relation aux mots, pensé pour créer un univers immersif porté par l’image et la sensibilité des plans.",
        en: "Narrative short film exploring language, emotion, and our relationship to words, designed to create an immersive world carried by the imagery and the sensitivity of the shots.",
      },
    },

    videos: [
      { type: "mp4", src: '/images/projects/f15/f15_ba.mp4', label: { fr: 'Bande-annonce', en: 'Trailer' } },
    ],

    images: [
      '/images/projects/f15/1.jpg',
      '/images/projects/f15/1.jpg',
      '/images/projects/f15/2.jpg',
      '/images/projects/f15/3.jpg',
      '/images/projects/f15/4.jpg',
      '/images/projects/f15/5.jpg',
      '/images/projects/f15/6.jpg',
      '/images/projects/f15/7.jpg',
    ],

    deckImages: [
      '/images/projects/f15/f15_hero.jpg',
      '/images/projects/f15/d1.jpg',
      '/images/projects/f15/d2.jpg',
      '/images/projects/f15/d3.jpg',
    ],
  },

  {
    id: '9',
    title: 'Sigil',
    thumbnail: '/images/projects/sigil/2.jpg',

    meta: {
      year: '2025',
      role: { fr: 'Superviseur VFX', en: 'VFX Supervisor' },
      type: 'Publicité',
      category: 'Ads'
    },

    content: {
      about: {
        fr: "Campagne visuelle pour un produit cosmétique réalisée en image de synthèse.",
        en: "Visual campaign for a cosmetic product, created entirely in CGI.",
      },
      intent: {
        fr: "Mettre en valeur la marque à travers une vidéo promotionnelle stylisée.",
        en: "Showcase the brand through a stylized promotional video.",
      },
      process: {
        fr: "Modélisation, animation et rendu sous Cinema 4D avec Octane.",
        en: "Modeling, animation, and rendering in Cinema 4D with Octane.",
      },
      summary: {
        fr: "Campagne visuelle pour un produit cosmétique réalisée en image de synthèse, pensée pour mettre en valeur la marque à travers une vidéo promotionnelle stylisée. Modélisation, animation et rendu réalisés sous Cinema 4D avec Octane.",
        en: "Visual campaign for a cosmetic product, created entirely in CGI and designed to showcase the brand through a stylized promotional video. Modeling, animation, and rendering done in Cinema 4D with Octane.",
      },
    },

    videos: [
      { type: "mp4", src: '/images/projects/sigil/sigil.mp4', label: { fr: 'extrait', en: 'clip' } },
    ],

    breakdownVideo: '/images/projects/sigil/sigildef.mp4',

    images: [
      '/images/projects/sigil/1.jpg',
      '/images/projects/sigil/1.jpg',
      '/images/projects/sigil/2.jpg',
    ],
  },

  {
    id: '2',
    title: 'FERRARI F40',
    thumbnail: '/images/projects/ferrari/ferrari_hero.jpg',

    meta: {
      year: '2025',
      role: { fr: 'Artiste vfx', en: 'VFX Artist' },
      type: 'Animation série',
      category: 'Animation'
    },

    content: {
      about: {
        fr: "Courte animation stylisée autour de la Ferrari F40.",
        en: "Short stylized animation centered on the Ferrari F40.",
      },
      intent: {
        fr: "Obtenir un rendu photoréaliste tout en conservant une esthétique cinématographique.",
        en: "Achieve a photorealistic render while keeping a cinematic aesthetic.",
      },
      process: {
        fr: "Modélisation, animation et lighting sous Cinema 4D avec Octane.",
        en: "Modeling, animation, and lighting in Cinema 4D with Octane.",
      },
      summary: {
        fr: "Courte animation stylisée autour de la Ferrari F40, pensée pour obtenir un rendu photoréaliste tout en conservant une esthétique cinématographique. Modélisation, animation et lighting réalisés sous Cinema 4D avec Octane.",
        en: "Short stylized animation centered on the Ferrari F40, designed to achieve a photorealistic render while keeping a cinematic aesthetic. Modeling, animation, and lighting done in Cinema 4D with Octane.",
      },
    },

    videos: [
      { type: "mp4", src: '/images/projects/ferrari/ferrari_final.mp4', label: { fr: 'extrait 1', en: 'clip 1' } },
    ],

    breakdownVideo: '/images/projects/ferrari/f40_making_of.mp4',

    images: [
      '/images/projects/ferrari/ferrari_hero.jpg',
      '/images/projects/ferrari/ferrari_hero.jpg',
      '/images/projects/ferrari/ferrari_1.jpg'
    ],

    deckImages: [
      '/images/projects/ferrari/ferrari_c1.jpg',
      '/images/projects/ferrari/ferrari_c2.jpg',
      '/images/projects/ferrari/ferrari_c3.jpg',
      '/images/projects/ferrari/ferrari_c4.jpg',
    ],
  },

  {
    id: '1',
    title: 'Hextech core',
    thumbnail: '/images/projects/hextech/hextech_hero.jpg',

    meta: {
      client: 'Hextech core',
      year: '2024',
      role: { fr: 'VFX Artist', en: 'VFX Artist' },
      type: 'Animation',
      category: 'Animation'
    },

    content: {
      about: {
        fr: "Court métrage d’animation expérimental inspiré de l’univers d’Arcane.",
        en: "Experimental animated short film inspired by the world of Arcane.",
      },
      intent: {
        fr: "Créer un monde photoréaliste tout en conservant une poésie visuelle.",
        en: "Create a photorealistic world while preserving a visual poetry.",
      },
      notes: {
        fr: "Projet personnel orienté recherche et développement.",
        en: "Personal project focused on research and development.",
      },
      summary: {
        fr: "Court métrage d’animation expérimental inspiré de l’univers d’Arcane, pensé pour créer un monde photoréaliste tout en conservant une poésie visuelle.",
        en: "Experimental animated short film inspired by the world of Arcane, designed to create a photorealistic world while preserving a visual poetry.",
      },
    },

    videos: [
      { type: "mp4", src: "/images/projects/hextech/hextech_vid.mp4", label: { fr: 'extrait 1', en: 'clip 1' } },
      { type: "mp4", src: '/images/projects/ferrari/f40_making_of.mp4', label: { fr: 'extrait 2', en: 'clip 2' } },
      { type: "instagram", src: "https://www.instagram.com/reel/DRm5lTyCDdU/", label: { fr: 'Reel', en: 'Reel' } },
    ],

    breakdownVideo: '/images/projects/hextech/hextech_vid.mp4',
    breakdownThumbnail: '/images/projects/hextech/hextech_hero.jpg',
    breakdownDuration: '5:42',

    images: [
      '/images/projects/hextech/hextech_hero.jpg',
      '/images/projects/hextech/hextech_hero.jpg',
      '/images/projects/hextech/hextech_1.jpg',
      '/images/projects/hextech/hextech_2.jpg',
      '/images/projects/hextech/hextech_3.jpg',
    ],

    deckImages: [
      '/images/projects/hextech/hextech_c1.jpg',
      '/images/projects/hextech/hextech_c2.jpg',
      '/images/projects/hextech/hextech_c3.jpg',
      '/images/projects/hextech/hextech_c4.jpg',
    ],
  },

  {
    id: '7',
    title: 'Nikon F35',
    thumbnail: '/images/projects/f35/1.jpg',

    meta: {
      year: '2024',
      role: { fr: 'Superviseur VFX', en: 'VFX Supervisor' },
      type: 'animation',
      category: 'Animation'
    },

    content: {
      about: {
        fr: "Projet narratif autour de la caméra Nikon F35.",
        en: "Narrative project built around the Nikon F35 camera.",
      },
      intent: {
        fr: "Mettre en valeur l’objet à travers une narration visuelle en trois plans.",
        en: "Showcase the object through a visual narrative told in three shots.",
      },
      notes: {
        fr: "Recherche artistique sur l’atmosphère et l’ambiance.",
        en: "Artistic exploration of mood and atmosphere.",
      },
      summary: {
        fr: "Projet narratif autour de la caméra Nikon F35, pensé pour mettre en valeur l’objet à travers une narration visuelle en trois plans.",
        en: "Narrative project built around the Nikon F35 camera, designed to showcase the object through a visual narrative told in three shots.",
      },
    },

    videos: [
      { type: "mp4", src: '/images/projects/f35/f35.mp4', label: { fr: 'extrait 1', en: 'clip 1' } },
    ],

    breakdownVideo: '/images/projects/f35/f35_mo.mp4',

    images: [
      '/images/projects/f35/1.jpg',
      '/images/projects/f35/1.jpg',
      '/images/projects/f35/2.jpg',
      '/images/projects/f35/3.jpg',
      '/images/projects/f35/4.jpg',
    ],
  },

];

export const services = [
  {
    title: 'Commercial VFX',
    description: 'High-impact visual effects for advertising campaigns and brand content'
  },
  {
    title: 'Film Production',
    description: 'Feature film visual effects from pre-vis to final composite'
  },
  {
    title: 'Series VFX',
    description: 'Episodic content with consistent quality and efficient workflows'
  },
  {
    title: 'Animation & 3D',
    description: 'Concept design, modeling, texturing, animation, and rendering for any project'
  }
];
